import { FETCH_SUPPORTTYPES_SUCCESS_ACTION, GET_TICKETS_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_SUPPORTTYPES_SUCCESS_ACTION:
      return {
        ...state,
        supportTypeList: action.payload.rows,
        supportTypeListCount: action.payload.count,
      };

    case GET_TICKETS_SUCCESS_ACTION:
// console.log(action.payload.rows);
      return {
        ...state,
        supportTickets:action.payload.rows,
        supportTicketsCount:action.payload.count,
      }
    
    default:
      return {
        ...state,
      };
  }
}
